import React, { useState}   from 'react';
import {Link} from 'react-router-dom';


import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';

import {login} from './../../services/firebase';


function Login(props) {

  /*const [variant, setVariant] = React.useState('');
  const [message, setMessage] = React.useState('');
  const [open, setOpen] = React.useState(false);*/
  
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const handleSubmit = (evt) => {
    evt.preventDefault();
    email && password &&
      login(email, password)
      .then(user =>{
          /*setVariant('success');
          setMessage('Success!');
          setOpen(true);*/
          console.log('Usuario autenticado');
          props.setAuthentication(true);
          sessionStorage.setItem('user',user.user.uid);        
      })
      .catch(err=>{
        console.log('Ocurrió un error');
       /* setVariant('error');
        setMessage('Credenciales inválidas');
        setOpen(true);*/
      });
  }
  
/*  const handleClose = (event, reason) => {
    setOpen(false);
  };*/
  
  return (
      <Grid container component="main" main className="principal">
      
      <Grid   justify="space-around" item xs={12} sm={6} md={7} className="home" class="col-sm-6" container-fluid>

      
          <div id="carousel-1" class="carousel1 slide" data-ride="carousel">
                    <div class="carousel-inner" role="listbox"> 
                        <div class="carousel-item active">
                            <img src="img4.jpg" class="img-fluid"  className="tam-img" ></img>
                        </div>
                      
                        <div class="carousel-item">
                             <img src="img3.jpg" class="img-fluid" className="tam-img"  ></img>
                        </div>
                        <div class="carousel-item">
                             <img src="img2.jpg" class="img-fluid" className="tam-img" ></img>
                        </div>
                        
                        <div class="carousel-item">
                             <img src="img5.jpg" class="img-fluid" className="tam-img"></img>
                        </div>
                    </div>
                </div>
            

      </Grid>
      <Grid item xs={12} sm={6} md={5} className="home home-left" >
    
      <Container component="main" maxWidth="xs" className="login">

      <form  noValidate>
        
        
            <Grid container spacing={2} justify="center" >
            <img   src="logo3.png" className="image"></img>
            <Grid item xs={12} sm={12}> 
          
            </Grid>
            <Grid item xs={12} sm={12}>
              <Typography component="h1" variant="h5" align="center" fontStyle="bold">
              Inicia sesión con Sharecipe
              </Typography>
            </Grid>
          
          
          
            <Grid alignItems="flex-end" item xs={12}>
              <TextField
                variant="outlined"
                required
                fullWidth
                id="email"
                label="Correo"
                type="email"
                name="email"
                autoComplete="email"              
                value={email}
                onChange={e => setEmail(e.target.value)}
              />
            </Grid>
            
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                required
                fullWidth
                name="password"
                label="Contraseña"
                type="password"
                id="password"              
                value={password}
                onChange={e => setPassword(e.target.value)}
              />
            </Grid>
            
          
          
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            onClick={handleSubmit}
          >
            Entrar
          </Button>


        
          
            <p>¿Ya tienes cuenta?<Link to="/password">¿Olvidaste tu contraseña?</Link></p>
            <p>¿Eres un Nuevo Chef?<Link to="/signup">Regístrate ahora »</Link></p>
            <p>¿Quienes somos?<Link to="/acerca">Acerca de nosotros</Link></p>

          
            </Grid>
          </form>
          
      
        </Container>
      </Grid> 
 
  </Grid>
  );
}

export default Login;
